import {applyMiddleware, createStore} from 'redux';
import reducer from './reducer';
import {logicMiddleware, logRocketReduxMiddleware} from "./middleware";



const store = createStore(reducer, applyMiddleware(logicMiddleware, logRocketReduxMiddleware));

export default store;